import School from '@/types/School';

export const getSchoolAddressLink = (school: School) => {
  const encoded = encodeURIComponent(
    `${school.address?.street}, ${school.address?.zipCode} ${school.address?.city}`
  );
  return 'https://www.google.com/maps/search/?api=1&query=' + encoded;
};
